var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<li class=\"gap page-item\">\n  "
    + ((stack1 = __default(require("../../javascript/src/shared/handlebars/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"js.pagination.truncate",{"name":"t","hash":{"defaultValue":"&hellip;"},"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":2,"column":58}}})) != null ? stack1 : "")
    + "\n</li>\n";
},"useData":true});